/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Annotations_WriteInputs */



/**
* | output |
* | --- |
* | "Create and edit timeline annotations" |
*
* @param {Perm_Product_Annotations_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_annotations_write = /** @type {((inputs?: Perm_Product_Annotations_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Annotations_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создавать и изменять аннотации на хронологии")
	return /** @type {LocalizedString} */ ("Create and edit timeline annotations")
});